import clsx from 'clsx';

// Types
import type { Posts } from '@/components/pages/giveaway-picker/Types/types';

// Components
import Icon from '@/components/base/Icon';
import { PostImage } from '@/components/pages/giveaway-picker/SelectPostWrapper/components/SelectPost/PostImage';

type PostProps = {
    post: Posts;
    summaryItem: boolean;
    selected?: boolean;
};

const IconWrapperClass = 'flex items-center gap-2 text-sm';

export const Post = ({ post, summaryItem, selected }: PostProps) => {
    return (
        <div
            className={clsx(
                'relative flex w-full flex-col items-center rounded-lg bg-icoGray-100 px-2 pb-4 pt-2',
                {
                    'max-w-[140px] bg-white': summaryItem
                }
            )}
            data-testid={`post-container-${post.id}`}>
            <span className="flex h-full w-full flex-col items-center justify-between gap-4">
                <PostImage post={post} summaryItem={summaryItem} selected={selected} />
                <div className="flex gap-m">
                    <div className={IconWrapperClass} data-testid="likes-container">
                        <Icon
                            icon="likes"
                            className={clsx('text-icoBlue', {
                                'text-xs': summaryItem
                            })}
                        />
                        <span
                            className={clsx({
                                'text-xs': summaryItem
                            })}
                            data-testid="likes-count">
                            {post?.metrics?.likes ?? 'N/A'}
                        </span>
                    </div>
                    <div className={IconWrapperClass} data-testid="comments-container">
                        <Icon
                            icon="comments"
                            className={clsx('text-icoBlue', {
                                'text-xs': summaryItem
                            })}
                        />
                        <span
                            className={clsx({
                                'text-xs': summaryItem
                            })}
                            data-testid="comments-count">
                            {post?.metrics?.comments ?? 'N/A'}
                        </span>
                    </div>
                </div>
            </span>
        </div>
    );
};
